import { getFlavorSearchQueries } from 'utils/api/flavors.api';
import { useQuery } from 'react-query';

function queryFn({ queryKey }) {
    return getFlavorSearchQueries({
        category: queryKey[1].category,
        country: queryKey[1].country,
        flavor: queryKey[1].flavor,
    });
}

export const getQueryKey = ({ category, country, flavor }) => {
    return [
        'flavor-search-queries',
        {
            category,
            country,
            flavor,
        },
    ];
};

const useFlavorSearchQueries = ({
    category,
    country,
    flavor,
    enabled = true,
}) => {
    const queryKey = getQueryKey({
        category,
        country,
        flavor,
    });
    const query = useQuery(queryKey, queryFn, {
        enabled,
        staleTime: Infinity,
    });
    return query;
};

export default useFlavorSearchQueries;
